






















import Vue from 'vue';

export default Vue.extend({
  name: 'MStoreModal',
  props: {
    header: {
      type: String,
      required: true
    },
    icon: {
      type: String
    },
    modalId: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'xl'
    },
    preventCloseBehaviour: {
      type: Boolean,
      default: false
    }
  }
});
